//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,

  props: {

    openOnHover: {
      type: Boolean,
      default: true,
    },

    closable: {
      type: Boolean,
      default: false
    },

    value: {
      type: Boolean,
      default: false
    },

    maxWidth: {
      type: Number,
      default: 250,
    },

    // content
    body: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },

    // for the style of the tooltip to be used in different situations (error, tour, info)
    type: {
      type: String,
      default: 'info',
      required: false
    },

    nudgeLeft: {
      type: Number,
      default: 0
    },

    nudgeRight: {
      type: Number,
      default: 0
    },

    nudgeBottom: {
      type: Number,
      default: 0
    },

    nudgeTop: {
      type: Number,
      default: 0
    },

    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },

    bottom: {
      type: Boolean,
      default: false
    },
    top: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    classes () {
      const style = []
      // arrow direction
      if (this.top) {
        style.push('k-tooltip--arrow-bottom')
      }
      if (this.right) {
        style.push('k-tooltip--arrow-left')
      }
      if (this.left) {
        style.push('k-tooltip--arrow-right')
      }
      if (this.bottom) {
        style.push('k-tooltip--arrow-top')
      }
      style.push('k-tooltip')
      // type of tooltip
      style.push('k-tooltip--' + this.type)
      return style
    },
  },
  updated () {
    this.$nextTick(() => {
      this.$refs.tooltip.updateDimensions()
    })
  },
  methods: {
    close () {
      this.$refs.tooltip.deactivate()
      this.$emit('close')
      this.$emit('input', false)
    }
  }
}
